export const RoutePaths = {
    HOME: '/',
    ABOUT: '/about',
    CONTACT: '/contact-us',
    SOLUTION: '/solutions/:id'
};